import { AuthGuard } from './auth.guard';

export const GUARDS = [AuthGuard];

export { AuthGuard };
